import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import SuperbetLobbyConponent from "../Components/SuperbetLobbyComponent";

interface SIL {
    atagParams: string | null,
    viewType?: string | null
    sourceParams: string | null,
    ticketOpenMode: string | null,
    botAccessToken?: string | null,
    botRefreshToken?: string | null,
}
const SuperbetLobby: FC <SIL> = ({atagParams, viewType, sourceParams, ticketOpenMode, botAccessToken, botRefreshToken}) => {
    const {getSuperbetsData} = useAction();
    const {superbetsData} = useTypedSelector((state) => state.superbetsReducer);

    useEffect(()=>{
        getSuperbetsData();
    }, [])
    return (
        <>
            {
                superbetsData.length > 0 ?
                    <SuperbetLobbyConponent
                        data={superbetsData}
                        sourceParams={sourceParams}
                        atagParams={atagParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                        botAccessToken={botAccessToken}
                        botRefreshToken={botRefreshToken}
                    />
                    : null
            }
        </>
    );

}

export default SuperbetLobby;